(function(){
    angular
        .module('app')
        .directive('ngReferenced', referencedDir);

    referencedDir.$inject = ['$compile']
     function referencedDir($compile){
	 // directive factory creates a link function
	 return {
	 require: 'ngModel',
	 scope:{'params':'='},
	  link:function(scope, element, attrs,ngModel) {
	  	scope.$watch("params",
	    function(valueV) {
	    	var json = JSON.stringify( valueV, function( key, value ) {
			    if( key === "$$hashKey" ) {
			        return undefined;
			    }
			    return value;
			});
	    	ngModel.$setViewValue(json);
	    },true);
	  }
	   
	 }
	}
})();